import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var PropiedadService = /** @class */ (function () {
    function PropiedadService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    PropiedadService.prototype.getPropiedad = function (rol, id, dir, num) {
        var params;
        if (rol && dir == undefined && num == undefined) {
            params = {
                rol: rol,
                id: id
            };
        }
        if (dir && num && rol == undefined) {
            params = {
                dir: dir,
                num: num
            };
        }
        console.log("getPropiedad() propiedad.service.ts", params);
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/propiedad', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    PropiedadService.prototype.savePropiedad = function (rol) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/propiedad', rol, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    PropiedadService.prototype.traerCalles = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            param: "param"
        };
        return this._http.post(this.url + 'traerCalles', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    PropiedadService.prototype.getCalles = function () {
        var headers = new Headers({
            'Content-type': 'application/json'
        });
        return this._http.get(this.url + 'get/calles', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return PropiedadService;
}());
export { PropiedadService };
